export default __webpack_public_path__ + "static/DSC_0182-78b5182a9df589c479575ce84cb3d778.jpg";